// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'

const loadThumbnails = async (manifestList) => {
  for (const item of manifestList) {
    if (!item.thumbnail) { continue }
    try {
      const fetchParams = {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + store.getters.jwt,
        },
      }
      const url = item.thumbnail.id
      const response = await fetchWithTimeout(url, fetchParams)

      if (response.ok) {
        const data = await response.blob()
        const imageValue = URL.createObjectURL(data)

        item.thumbnail.url = imageValue
      } else {
        console.error(`Failed to fetch thumbnail for item ${item.id}:`, response.statusText)
      }
    }
    catch (e) {
      console.error(`Error fetching thumbnail for item ${item.id}:`, e)
    }
  }

  return manifestList
}

export default loadThumbnails
